'use client';

import { Check, Minus } from '@phosphor-icons/react/ssr';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import * as React from 'react';

import { checkboxBox } from '../lib/checkbox-styles';

/**
 * shadcn Checkbox (Radix), restyled to the Figma Checkbox box. Supports
 * `checked="indeterminate"`. Apps use `Checkbox` (components/lib), which adds
 * the label.
 */
function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={checkboxBox({ className })}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center"
      >
        {props.checked === 'indeterminate' ? (
          <Minus aria-hidden />
        ) : (
          <Check aria-hidden />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
